module.exports = __webpack_public_path__ + "media/images/dribbble-471f8a9af61b605c63de8143161dedb9.png";